import { render, staticRenderFns } from "./InputAktivitas.vue?vue&type=template&id=3efb0a7e&scoped=true&lang=html&"
import script from "./InputAktivitas.vue?vue&type=script&lang=js&"
export * from "./InputAktivitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb0a7e",
  null
  
)

export default component.exports